import { render, staticRenderFns } from "./point-order-point-btn.vue?vue&type=template&id=7867c984&scoped=true"
import script from "./point-order-point-btn.vue?vue&type=script&lang=js"
export * from "./point-order-point-btn.vue?vue&type=script&lang=js"
import style0 from "./point-order-point-btn.vue?vue&type=style&index=0&id=7867c984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7867c984",
  null
  
)

export default component.exports